var map = {
	"./Untitled design (4).png": 129,
	"./address_image.svg": 130,
	"./amit.png": 55,
	"./animated_logo.svg": 131,
	"./blogs_image.svg": 132,
	"./bridge.png": 133,
	"./cloud_infrastructure.svg": 134,
	"./codeInLogo.png": 135,
	"./contactMail.png": 136,
	"./data_science.svg": 137,
	"./deeplearning_ai_logo.png": 138,
	"./delhivery_logo.png": 139,
	"./developerActivity.svg": 140,
	"./dmun.png": 141,
	"./dsc_logo.png": 142,
	"./education.svg": 143,
	"./experience.svg": 144,
	"./feelingProud.svg": 145,
	"./fullstack.svg": 146,
	"./github_logo.png": 147,
	"./googleAssistant.jpg": 148,
	"./intel_logo.jpg": 149,
	"./ioelogo.png": 150,
	"./jsFramework.svg": 151,
	"./mozilla_logo.png": 152,
	"./portfolio.gif": 153,
	"./programmer.svg": 154,
	"./projects_image.svg": 155,
	"./pwa.png": 156,
	"./sbe.png": 157,
	"./stanford_logo.png": 158,
	"./stc.png": 159,
	"./talksCardBack.svg": 160,
	"./talksCardBackAlt.svg": 161,
	"./ui_ux_design.svg": 162,
	"./uow.png": 163
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 32;